/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import { apiDataToDropdownList } from "../../../utils/sysHelpers";
import SysTable from "../../commonComponents/SysTable";

class UserManagement extends Component {
  state = {
    data: {
      Username: "",
      FirstName: "",
      LastName: "",
      UserRole: "",
      UserServices: [],
      UserCompounds: []
    },

    contentHeader: "Users",
    addButtonLabel: "Add User",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/getusers",
    singleItemUrl: "/api/data/getuser",
    addUrl: "/api/data/adduser",
    editUrl: "/api/data/edituser",
    deleteUrl: "/api/data/deleteuser",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add User",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit User",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    rolesDropdown: [],
    allCategory: [],
    allServices: [],
    allCompounds: [],

    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.username"),
        field: "USERNAME",
      },
      {
        id: 2,
        label: t("col.blocked"),
        field: "IS_BLOCKED",
        cellRenderer: ({ data }) => {
          return data.IS_BLOCKED === "Y" ? "Yes" : "No";
        },
      },
      {
        id: 3,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 4,
        label: t("col.firstName"),
        field: "FIRST_NAME",
      },
      {
        id: 5,
        label: t("col.lastName"),
        field: "LAST_NAME",
      },
      {
        id: 6,
        label: t("col.roleName"),
        field: "ROLE_NAME",
      },
      {
        id: 7,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "120px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CAC0"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CAC1"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CAC2"]) && (
                <div className="inner" title="Block">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleBlock(data)}
                  >
                    <i className="fa fa-ban" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CAC3"]) && (
                <div className="inner" title="Unblock">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleUnblock(data)}
                  >
                    <i className="fa fa-check" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CAC4"]) && (
                <div className="inner" title="Reset Password">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleResetPassword(data)}
                  >
                    <i className="fa fa-key" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });

    this.getRolesDropdown();
    this.getAllServices();
    this.getAllCompounds();
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
      rolesDropdown: [],
      allServices: [],
      allCompounds: [],
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { UserId: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["Username"] = apiResponse.data.respData.data[0].USERNAME;
      data["FirstName"] = apiResponse.data.respData.data[0].FIRST_NAME;
      data["LastName"] = apiResponse.data.respData.data[0].LAST_NAME;
      data["UserRole"] = apiResponse.data.respData.data[0].ROLE_ID_FK;
      const serviceItems = apiResponse.data.respData.services || [];
      const compoundItems = apiResponse.data.respData.compounds || [];

      const toId = item => (item !== null && typeof item === 'object') ? item.value : item;
      serviceItems.forEach(s => data["UserServices"].push(toId(s)));
      compoundItems.forEach(c => data["UserCompounds"].push(toId(c)));

      const seedServices = serviceItems.filter(s => s !== null && typeof s === 'object' && s.label);
      const seedCompounds = compoundItems.filter(c => c !== null && typeof c === 'object' && c.label);

      this.setState({
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
        ...(seedServices.length > 0 && { allServices: seedServices }),
        ...(seedCompounds.length > 0 && { allCompounds: seedCompounds }),
      });
    });
  }

  getAllServices() {
    post("/api/data/getallservices", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        const fetched = apiDataToDropdownList(apiResponse.data.respData.data, "label", "value");
        const existing = this.state.allServices;
        const merged = [...fetched];
        existing.forEach(e => { if (!merged.find(m => m.value === e.value)) merged.push(e); });
        this.setState({ allServices: merged });
      }
    );
  }

  getAllCompounds() {
    post("/api/data/GetAllCompoundsDropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        const fetched = apiDataToDropdownList(apiResponse.data.respData.data, "label", "value");
        const existing = this.state.allCompounds;
        const merged = [...fetched];
        existing.forEach(e => { if (!merged.find(m => m.value === e.value)) merged.push(e); });
        this.setState({ allCompounds: merged });
      }
    );
  }

  getRolesDropdown() {
    post("/api/data/getrolesdropdown", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          rolesDropdown: apiDataToDropdownList(
            apiResponse.data.respData.data,
            "ROLE_NAME",
            "ID"
          ),
        });
      }
    );
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { UserId: row.ID, Username: row.USERNAME },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  handleBlock(row) {
    post(
      "/api/data/blockuser",
      { UserId: row.ID, Username: row.USERNAME },
      this.props.updateIsLoading
    ).then(() => this.getData());
  }

  handleUnblock(row) {
    post(
      "/api/data/unblockuser",
      { UserId: row.ID, Username: row.USERNAME },
      this.props.updateIsLoading
    ).then(() => this.getData());
  }

  handleResetPassword(row) {
    post(
      "/api/data/resetpassword",
      { UserId: row.ID, Username: row.USERNAME },
      this.props.updateIsLoading
    ).then(() => this.getData());
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData.EditEntityId = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.users")}</h4>
          </div>
          <div className="col flex-container-left">
            <Button
              label={t("pages.addUser")}
              icon={this.state.addButtonIcon}
              className="p-button-rounded p-button-secondary"
              disabled={this.props.isLoading}
              onClick={() => {
                this.setState({ inEditMode: false });
                this.showForm();
              }}
            />
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "Username",
                label: t("col.username"),
                disabled: this.state.inEditMode ? true : false,
              },
              {
                type: "text",
                id: "FirstName",
                label: t("col.firstName"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "UserRole",
                label: t("col.role"),
                options: this.state.rolesDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "LastName",
                label: t("col.lastName"),
                disabled: false,
              },
              {
                type: "multiselect",
                id: "UserServices",
                label: t("col.userServices"),
                options: this.state.allServices,
                disabled: false,
              },
              {
                type: "multiselect",
                id: "UserCompounds",
                label: t("col.userCompounds"),
                options: this.state.allCompounds,
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(UserManagement);
